import { Component } from '@angular/core';

import { MainHeaderComponent } from 'src/app/shared/components/main-header/main-header.component';

@Component({
    selector: 'kh-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    imports: [MainHeaderComponent]
})
export class ErrorPageComponent {

    constructor() { }

}
